import { configureStore } from '@reduxjs/toolkit'
import modeReducer from './slices/mode'

const store = configureStore({
    reducer: {
        mode: modeReducer
    }
})

export default store